module.exports = __webpack_public_path__ + "img/img96.41ada855.png";